import { useState } from "react";

/**
 * A person's picture. The server always sends a URL (Google photo, Gravatar or
 * an initials image), but a CDN can still fail, so a broken image falls back
 * to the initial rather than to a broken-image icon.
 */
export function Avatar({ name, url, size = 26 }: { name: string; url?: string; size?: number }) {
  const [broken, setBroken] = useState(false);
  const style = { width: size, height: size };
  if (url && !broken) {
    return (
      <img
        src={url}
        alt=""
        referrerPolicy="no-referrer"
        onError={() => setBroken(true)}
        style={style}
        className="shrink-0 rounded-full object-cover"
      />
    );
  }
  return (
    <span
      aria-hidden
      style={style}
      className="grid shrink-0 place-items-center rounded-full bg-accent text-[11px] font-bold text-ground"
    >
      {name.trim()[0]?.toUpperCase() ?? "?"}
    </span>
  );
}
